<template>
	<section class="hero-section">
		<Row class="relative z-[2]">
			<Container
				class="flex min-h-[572px] flex-wrap justify-center lg:justify-between lg:flex-nowrap items-center"
			>
				<div class="flex w-full max-w-[400px] flex-col gap-[32px]">
					<h1 class="gradient-title-white text-center lg:text-left">
						Trading tips & trends, delivered.
					</h1>

					<div
						id="hero-lead-capture-form"
						class="flex flex-col gap-[32px]"
					>
						<h3
							id="hero-subtitle"
							class="text-lg text-white max-w-[612px] text-center lg:text-left"
						>
							Get the latest stocks and trading insights every week. Straight to your
							inbox.
						</h3>
						<LeadCaptureForm
							id="sttwl-mainsite-top"
							cta-appearence="primary"
							class="max-w-[600px]"
							button-text="Subscribe"
						/>
					</div>
				</div>

				<NuxtLink
					v-if="post"
					:href="`/${post.slug}/`"
					class="mt-[32px] lg:mt-0 items-stretch shadow-2xl bg-white flex w-full max-w-[720px] overflow-hidden flex-col pb-3.5 rounded-2xl max-md:max-w-full"
				>
					<img
						loading="lazy"
						width="720"
						height="394"
						:src="
							post._embedded && post._embedded['wp:featuredmedia']
								? post._embedded['wp:featuredmedia'][0].source_url
								: '/images/daily-acelerator.webp'
						"
						class="object-contain object-center w-full overflow-hidden max-md:max-w-full"
					/>
					<div
						class="items-stretch flex w-full flex-col mt-6 px-[16px] lg:px-[32px] max-md:max-w-full"
					>
						<h1
							class="overflow-hidden text-blue-500 text-ellipsis text-sm font-bold leading-5 w-full mb-[8px]"
						>
							{{ category.name }}
						</h1>
						<h2
							class="overflow-hidden text-black text-ellipsis mb-[16px] lg:mb-[24px] text-[22px] lg:text-4xl font-medium leading-tight tracking-tighter"
						>
							{{ post.title.rendered }}
						</h2>
						<div class="items-center inline-flex w-full justify-between">
							<div class="items-stretch flex justify-between gap-2">
								<img
									loading="lazy"
									:src="post._embedded['author'][0].avatar_urls['48']"
									class="aspect-square object-contain object-center w-[32px] overflow-hidden shrink-0 rounded-[48px]"
								/>
								<p
									class="text-black text-sm font-medium leading-5 self-center grow whitespace-nowrap my-auto"
								>
									Tim Bohen
								</p>
							</div>
							<div class="items-center flex gap-2">
								<img
									loading="lazy"
									src="https://cdn.builder.io/api/v1/image/assets/TEMP/e1056984227e90b51177cff1cd6e9ce5440a12f9f668cbb2f111d53005f54743?apiKey=da983b91ec1d46989670bd2839624a11&"
									class="aspect-square object-contain object-center w-[24px] lg:w-[32px] overflow-hidden shrink-0"
								/>
								<p
									class="text-black text-sm font-medium leading-5 self-center grow whitespace-nowrap my-auto"
								>
									{{ calculateReadingTime(post.content.rendered) }} min read
								</p>
							</div>
						</div>
					</div>
				</NuxtLink>
				<div
					v-else
					class="mt-[32px] lg:mt-0 items-stretch shadow-2xl bg-white flex w-full max-w-[720px] overflow-hidden flex-col pb-3.5 rounded-2xl max-md:max-w-full"
				>
					<div
						class="object-contain object-center w-full overflow-hidden block h-full min-h-[252px] max-w-[720px] lg:min-h-[394px] bg-slate-100"
					></div>

					<div
						class="items-stretch flex w-full flex-col mt-6 px-[16px] gap-[16px] lg:px-[32px]"
					>
						<span class="bg-slate-100 w-full h-[36px]"></span>

						<span class="bg-slate-100 w-full h-[22px]"></span>

						<div class="items-center inline-flex w-full justify-between">
							<div class="items-stretch flex justify-between gap-2">
								<span
									class="aspect-square bg-slate-100 rounded-[32px] object-contain object-center w-[34px] overflow-hidden shrink-0 max-w-full"
								/>
								<div class="w-[200px] h-[16px] bg-slate-100"></div>
							</div>
							<div class="items-center flex gap-2">
								<span
									class="aspect-square bg-slate-100 rounded-[32px] object-contain object-center w-[34px] overflow-hidden shrink-0 max-w-full"
								/>

								<div class="w-[64px] h-[16px] bg-slate-100"></div>
							</div>
						</div>
					</div>
				</div>
			</Container>
		</Row>
	</section>
</template>

<script setup>
const { hostname } = useRuntimeConfig().public;

defineProps(["category", "post"]);

onMounted(() => {
	if (import.meta.client) {
		const textWrapper = document.querySelector(".gradient-title-white");
		textWrapper.innerHTML = textWrapper.textContent.replace(
			/\S/g,
			"<span class='letter'>$&</span>"
		);

		// anime
		// 	.timeline()
		// 	.add({
		// 		targets: ".gradient-title-white",
		// 		opacity: [0, 1],
		// 		easing: "easeInOutQuad",
		// 		duration: 10
		// 	})
		// 	.add({
		// 		targets: ".gradient-title-white .letter",
		// 		opacity: [0, 1],
		// 		easing: "easeInOutQuad",
		// 		duration: 500,
		// 		delay: (el, i) => 15 * (i + 1)
		// 	})
		// 	.add({
		// 		targets: "#hero-subtitle",
		// 		opacity: [0, 1],
		// 		easing: "easeInOutQuad",
		// 		translateY: [25, 0],
		// 		duration: 350
		// 	})
		// 	.add({
		// 		targets: "#hero-lead-capture-form",
		// 		opacity: [0, 1],
		// 		easing: "easeInOutQuad",
		// 		translateY: [25, 0],
		// 		duration: 500
		// 	});

		// anime
		// 	.timeline()
		// 	.add({
		// 		targets: "#shine",
		// 		easing: "easeInOutQuad",
		// 		opacity: [0, 1],
		// 		translateX: [800, 0],
		// 		duration: 500,
		// 		delay: 250
		// 	})
		// 	.add({
		// 		targets: ".hero-image-2",
		// 		easing: "easeInOutQuad",
		// 		opacity: [0, 1],
		// 		translateX: [800, 0],
		// 		duration: 500
		// 	});
	}
});
</script>
<style lang="scss" scoped>
@use "~/assets/utils.scss" as *;

.hero-image-container {
	position: relative;

	// height: 636px;
	// width: 700px;
	@include breakpoint(lg) {
		position: unset;
	}
}
.hero-shine {
	position: absolute;
	top: 16px;
	z-index: 1;
	height: 36px;
	@include breakpoint(lg) {
		height: 64px;
		right: 564px;
		top: -364px;
		bottom: 0;
		margin: auto;
	}
}
.swoosh {
	position: absolute;
	top: 76px;
	left: 16px;
	margin: auto;
	z-index: 1;
	width: calc(100% - 36px);
	@include breakpoint(lg) {
		top: 0;
		bottom: 0;
		right: 24px;
		left: unset;
		width: auto;
	}
}

h1.gradient-title-white {
	opacity: 1 !important;
}
h1.gradient-title-white .letter {
	opacity: 1 !important;
}
</style>
